export const CLEAR_EVENT = "clear";
export const REDO_EVENT = "redo";
export const UNDO_EVENT = "undo";
